module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "account-system"
  }, [_c('router-view'), _vm._v(" "), _c('footer', {
    on: {
      "click": function($event) {
        _vm.goJump()
      }
    }
  }, [_vm._v("©2014-2016 京ICP备13001365号-1 北京屏芯科技有限公司版权所有")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d17f4f6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/router/AccountSystem/AccountSystem.vue
// module id = 762
// module chunks = 22